import { selectors } from 'data'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import KYC from './Form/Steps'

// Watchs for changes in user (login for example) and triggers KYC if not verified yet
const CheckBasicKYC = ({ children }) => {
  const user = useSelector(selectors.auth.getUser)
  const [showSignup, setShowSignup] = useState(false)

  useEffect(
    function watchUserForKYCEffect() {
      // once doing KYC don't stop until done
      if (showSignup) return
      const needsSignup = !!user && user?.state !== 'ACTIVE'
      setShowSignup(needsSignup)
    },
    [user]
  )

  if (!user) return children

  if (showSignup) {
    return <KYC user={user} onDone={() => setShowSignup(false)} />
  }

  return children
}

export default CheckBasicKYC
